import { CmpApi } from '@iabtcf/cmpapi'
import { TCModel, TCString, GVL, VendorList } from '@iabtcf/core'
import { AC } from '../ac/AC'
import { Cookie } from '../../helpers'
import { queryParamHas } from '../../helpers/getQueryParam'
import WebModel from '../../models/WebModel'
import Logger from '../../helpers/Logger'
import mvFetch from '../../helpers/mvFetch'

const COOKIE_EXPIRES = 365
const ID = 46
const VERSION = 2
const SERVICE_SPECIFIC_SCOPE = true 

export class TCF {
  public static cmpApi: CmpApi
  public static cookie: Cookie<string> = new Cookie(
    'euconsent-v2',
    COOKIE_EXPIRES
  )
  public static tcModel: TCModel
  public static tcString: string
  private static isGdprTest: boolean = queryParamHas('test', 'gdpr')
  private static gvl: GVL

  /**
   * Initializes the cmpApi, tcModel, and tcString static properties
   */
  public static async init({ gdpr, launcherUrl }: IWebViewModel | WebModel) {
    // We use the cmpiApi middleware to insert Google's addtlConsent string
    TCF.cmpApi = new CmpApi(ID, VERSION, SERVICE_SPECIFIC_SCOPE, {
      'getTCData': (next, tcData, status) => {
        tcData.addtlConsent = AC.value
        next(tcData, status)
      },
      'addEventListener': (next, tcData, status) => {
        tcData.addtlConsent = AC.value
        next(tcData, status)
      }
    })
    if (gdpr === '1' || TCF.isGdprTest) {
      try {
        // Ensure we always have a GVL available for use
        let fetchedGvl: object | undefined = window.$mediavine.web.model.gvl
        if (!fetchedGvl) {
          fetchedGvl = await mvFetch.fetchJson(`${launcherUrl}/cmp/vendor-list.json`, 'GET')
        }
        TCF.gvl = new GVL(fetchedGvl as VendorList)
      } catch (error) {	
        const errorMessage = 'GDPR: Error loading the GVL'	
        Logger.custom(['debug', 'gpdr'], errorMessage)	
        window.$mediavine.newrelic.addPageAction('gdprError', { error, errorMessage })	
      }

      if (TCF.cookie.value) {
        TCF.tcString = TCF.cookie.value
        TCF.tcModel = TCString.decode(TCF.tcString)
        TCF.tcModel.gvl = TCF.gvl
        TCF.tcModel.publisherCountryCode = 'US'
        TCF.tcModel.supportOOB = false
      } else {
        TCF.tcModel = new TCModel()
        TCF.tcModel.isServiceSpecific = SERVICE_SPECIFIC_SCOPE
        TCF.tcModel.cmpId = ID
        TCF.tcModel.cmpVersion = VERSION
        TCF.tcModel.gvl = TCF.gvl
        TCF.tcModel.publisherCountryCode = 'US'
        TCF.tcModel.supportOOB = false
        TCF.tcString = TCString.encode(TCF.tcModel)
      }
    }
  }

  /** Encodes an updated tcString when applicable; informs the cmpApi about the UI status*/
  public static consentDoesApply({ displayUi }: { displayUi: boolean }): void {
    if (displayUi) {
      // inform cmpApi we're opening the UI but we don't have consent yet
      TCF.cmpApi.update('', displayUi)
    } else {
      // inform cmpApi we're closing the UI and we have consent
      TCF.tcString = TCString.encode(TCF.tcModel)
      TCF.cmpApi.update(TCF.tcString, displayUi)
    }
  }

  /** Informs the cmpiApi that consent does not apply */
  public static consentDoesNotApply(): void {
    TCF.cmpApi.update(null, false)
  }

  /** Sets the 'euconsent-v2' cookie with the TCF.tcString value */
  public static setCookie(): void {
    TCF.cookie.set(TCF.tcString)
  }
}
